module.exports = __webpack_public_path__ + "img/fbe-logo.b32cd78f.svg";